import React from 'react';
import { Box } from '@mui/material';

interface RightDrawerProps {
  open: boolean;
  onClose: () => void;
  width?: { xs?: string | number; sm?: string | number };
  children: React.ReactNode;
}

export const RightDrawer: React.FC<RightDrawerProps> = ({
  open,
  onClose,
  width = { xs: '100%', sm: '500px' },
  children,
}) => {
  return (
    <>
      {/* Backdrop */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: (theme) => theme.zIndex.drawer + 2, // メインメニューより上、Drawerより下
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        onClick={onClose}
      />
      {/* Drawer */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: width,
          backgroundColor: '#F7F7F7',
          zIndex: (theme) => theme.zIndex.drawer + 3, // Backdropより上
          boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.15)',
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 225ms cubic-bezier(0.4, 0, 0.2, 1)',
          display: 'flex',
          flexDirection: 'column',
          pointerEvents: open ? 'auto' : 'none',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </Box>
    </>
  );
};

